import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import {Helmet} from "react-helmet";
import {getCachedImageUrl} from "../../../../utils/utils";
import LiveHlsPlayer from "../../squadflixVideoView/liveHlsPlayer/LiveHlsPlayer";
import {LeagueEvent} from "../../../../apis/towers-sports-api/types";
import LiveStreamPlayer from "../../squadflixVideoView/liveStreamPlayer/liveStreamPlayer";
import {VlcUtils} from "../../movies/utils/vlcUtils";

const hlsUrl = "https://torresowo.myftp.org:9994/hls/manifest.m3u8?id=STREAM_ID";
const streamUrl = "https://torresowo.myftp.org:9994/hls/streamAceLink?id=STREAM_ID"

type Props = {
    streamId: string;
    title?: string;
    onClose?: () => void;
}

const LiveAcestreamPlayer = ({streamId, title, onClose}: Props) => {

    const navigate = useNavigate();
    const [event, setEvent] = useState<LeagueEvent>(null);
    const [streamMode, setStreamMode] = useState(localStorage.getItem("favourite-acestream-streammode") || "stream");

    const options = [
        {
            label: <>
                {streamMode === "hls" &&
                    <span><i className="fa-solid fa-satellite-dish fa-lg"></i></span>}
                {streamMode === "stream" && <span><i className="fa-solid fa-wave-square fa-lg"></i></span>}
            </>,
            title: streamMode === "stream" ? "Cambiar a HLS" : "Cambiar a Streaming",
            onClick: () => {
                if (streamMode === "hls") {
                    setStreamMode("stream");
                    localStorage.setItem("favourite-acestream-streammode", "stream");
                } else {
                    setStreamMode("hls");
                    localStorage.setItem("favourite-acestream-streammode", "hls");
                }
            }
        }, {
            label: <> <img height={25} alt="Ace Stream"
                           src="https://dashboard.snapcraft.io/site_media/appmedia/2017/02/icon_14.png"/>
            </>,
            title: "Abrir en acestream",
            onClick: () => {
                window.open(`acestream://${streamId}`);
            }
        }, {
            label: <>
                <img height={20} src="https://cdn-icons-png.flaticon.com/512/732/732256.png" alt="vlc"/>
            </>,
            title: "Reproducir en VLC",
            onClick: e => {
                if (streamMode === "hls") {
                    VlcUtils.openInVlc(e, hlsUrl.replace("STREAM_ID", streamId))
                } else {
                    VlcUtils.openInVlc(e, streamUrl.replace("STREAM_ID", streamId))
                }
            }

        }
    ]

    return (
        <>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>{title || "Acestream Link"}</title>
                <link rel="icon"
                      href={getCachedImageUrl("https://play-lh.googleusercontent.com/daJbjIyFdJ_pMOseXNyfZuy2mKOskuelsyUyj6AcGb0rV0sJS580ViqOTcSi-A1BUnI")}/>
            </Helmet>
            {streamMode === "hls" && <LiveHlsPlayer
                showDebugInfo={false}
                title={title}
                className="ace-stream-video-player"
                autoPlay={true} muted={false}
                onClose={onClose}
                extraBtns={options}
                src={hlsUrl.replace("STREAM_ID", streamId)}
                poster={undefined} hlsConfig={undefined} onStatusChange={undefined}/>}
            {streamMode === "stream" && <LiveStreamPlayer
                title={title}
                className="ace-stream-video-player"
                autoPlay={true}
                onClose={onClose}
                extraBtns={options}
                src={streamUrl.replace("STREAM_ID", streamId)}/>
            }
        </>
    )
}

export default LiveAcestreamPlayer;
